var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-card-header',[_c('h3',[_vm._v(_vm._s(_vm.msg))])]),_c('b-card-body',[_c('initiative-tracker')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }